"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _variable = _interopRequireDefault(require("./variable"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var AnswerVariable = /*#__PURE__*/function (_Variable) {
  function AnswerVariable(variable) {
    (0, _classCallCheck2["default"])(this, AnswerVariable);
    Entry.assert(variable.variableType === 'answer', 'Invalid variable type given');
    return _callSuper(this, AnswerVariable, [variable]);
  }
  (0, _inherits2["default"])(AnswerVariable, _Variable);
  return (0, _createClass2["default"])(AnswerVariable, [{
    key: "updateView",
    value: function updateView() {
      if (!this.view_) {
        return;
      }
      if (this.isVisible()) {
        this._adjustSingleViewPosition();
        this.textView_.text = this.getName();
        if (this.isNumber()) {
          var v = Number(this.getValue());
          if (parseInt(this.getValue(), 10) == this.getValue()) {
            this.valueView_.text = v;
          } else {
            this.valueView_.text = Number(v).toFixed(1).replace('.00', '');
          }
        } else {
          this.valueView_.text = this.getValue();
        }
        if (this._nameWidth === null) {
          this._nameWidth = this.textView_.getMeasuredWidth();
        }
        this._adjustSingleValueViewPosition();
        if (this._valueWidth === null) {
          this._valueWidth = this.valueView_.getMeasuredWidth();
        }
        this._adjustSingleViewBox('#F57DF1');
        Entry.requestUpdate = true;
      }
    }
  }]);
}(_variable["default"]);
var _default = exports["default"] = AnswerVariable;